const Search = (props: React.SVGAttributes<SVGSVGElement>) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.90785 13.0999C10.3292 12.9063 10.8366 12.9579 11.1645 13.2858L13.5563 15.6777C13.9469 16.0682 14.58 16.0682 14.9706 15.6777L15.6777 14.9706C16.0682 14.58 16.0682 13.9469 15.6777 13.5563L13.2858 11.1645C12.9579 10.8366 12.9063 10.3292 13.0999 9.90785C14.2029 7.50754 13.7658 4.57342 11.7886 2.59619C9.25017 0.0577861 5.1346 0.0577861 2.59619 2.59619C0.0577813 5.1346 0.0577809 9.25017 2.59619 11.7886C4.57341 13.7658 7.50753 14.2029 9.90785 13.0999ZM4.0104 10.3744C5.76776 12.1317 8.617 12.1317 10.3744 10.3744C12.1317 8.61701 12.1317 5.76777 10.3744 4.01041C8.617 2.25305 5.76776 2.25305 4.0104 4.01041C2.25304 5.76777 2.25304 8.61701 4.0104 10.3744Z'
            fill='white'
        />
    </svg>
);

export default Search;
